import React from "react";
import { Message } from "primereact/message";

const BaseMessages = React.forwardRef((props,ref) => {
  return (<Message {...props} ref={ref} className={`${props.custom ? props.custom : ""} ${props.extra ? props.extra : ""}`}/>);
})

export default BaseMessages;